<template>
  <el-card class="card linkInfoSection">
    <div slot="header">
      <strong class="linkInfoSection__title">过滤条件</strong>
    </div>

    <dl class="linkInfoFilter">
      <div class="linkInfoFilter__item">
        <dt class="linkInfoFilter__label">国家</dt>
        <dd
          class="linkInfoFilter__value"
          :class="{ 'linkInfoFilter__value--muted': !countryView.configured }"
        >
          {{ countryView.text }}
        </dd>
      </div>

      <div class="linkInfoFilter__item">
        <dt class="linkInfoFilter__label">Android 系统版本</dt>
        <dd
          class="linkInfoFilter__value"
          :class="{ 'linkInfoFilter__value--muted': androidView === '未配置' }"
        >
          {{ androidView }}
        </dd>
      </div>

      <div class="linkInfoFilter__item">
        <dt class="linkInfoFilter__label">iOS 系统版本</dt>
        <dd
          class="linkInfoFilter__value"
          :class="{ 'linkInfoFilter__value--muted': iosView === '未配置' }"
        >
          {{ iosView }}
        </dd>
      </div>

      <div class="linkInfoFilter__item linkInfoFilter__item--block">
        <dt class="linkInfoFilter__label">应用版本</dt>
        <dd class="linkInfoFilter__value">
          <div v-if="appVersionRows.length" class="linkInfoFilter__table">
            <div class="linkInfoFilter__tableHead">
              <span>版本区间</span>
              <span>跳过版本</span>
              <span>数据集</span>
            </div>
            <div
              v-for="(row, index) in appVersionRows"
              :key="'classify-app-ver-' + index"
              class="linkInfoFilter__tableRow"
            >
              <span>{{ row.range }}</span>
              <span>{{ row.skip }}</span>
              <span>{{ row.dataSet }}</span>
            </div>
          </div>
          <span v-else class="linkInfoFilter__value--muted">未配置</span>
        </dd>
      </div>
    </dl>
  </el-card>
</template>

<script>
import {
  buildClassifyAppVersionRows,
  buildClassifyCountryView,
  buildClassifyOsVersionText,
} from './classifyInfoHelper'

export default {
  name: 'ClassifyFilterReadonly',
  props: {
    country: { type: Object, default: () => ({ isExclude: true, countries: [] }) },
    iosVersion: { type: Object, default: () => ({}) },
    androidVersion: { type: Object, default: () => ({}) },
    appVersion: { type: Array, default: () => [] },
    dataOptions: { type: Array, default: () => [] },
  },
  computed: {
    countryView() {
      return buildClassifyCountryView(this.country)
    },
    androidView() {
      return buildClassifyOsVersionText(this.androidVersion)
    },
    iosView() {
      return buildClassifyOsVersionText(this.iosVersion)
    },
    appVersionRows() {
      return buildClassifyAppVersionRows(this.appVersion, this.dataOptions)
    },
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkTypography.css';

.linkInfoSection {
  margin-bottom: 16px;
}

.linkInfoSection__title {
  font-size: var(--link-text-lg);
  font-weight: var(--link-font-semibold);
}

.linkInfoFilter {
  margin: 0;
  display: grid;
  gap: 14px;
}

.linkInfoFilter__item {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.linkInfoFilter__item--block {
  align-items: start;
}

.linkInfoFilter__label {
  margin: 0;
  padding-top: 2px;
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
}

.linkInfoFilter__value {
  margin: 0;
  font-size: var(--link-text-md);
  color: var(--link-ink);
  word-break: break-word;
}

.linkInfoFilter__value--muted {
  color: var(--link-ink-muted);
}

.linkInfoFilter__table {
  width: 100%;
  max-width: 640px;
  border: 1px solid var(--link-line, #eee9e2);
  border-radius: 8px;
  overflow: hidden;
}

.linkInfoFilter__tableHead,
.linkInfoFilter__tableRow {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 12px;
  padding: 10px 12px;
}

.linkInfoFilter__tableHead {
  font-size: var(--link-text-xs);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
  background: var(--link-canvas, #f5f2ec);
}

.linkInfoFilter__tableRow {
  font-size: var(--link-text-sm);
  border-top: 1px solid var(--link-line, #eee9e2);
}

@media (max-width: 640px) {
  .linkInfoFilter__item {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .linkInfoFilter__tableHead,
  .linkInfoFilter__tableRow {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
</style>
